import CertsListHeaderTabs from './CertsListHeaderTabs';

export default CertsListHeaderTabs;
